import { ComponentsVariants, isVariantOf } from '../../../components.variants';
import resolveRichTextContent from '../resolveRichTextContent';

export const isRichTextContent = isVariantOf(ComponentsVariants.RICH_TEXT, true);

export default (raw: any): RichTextContentType & { variant: ComponentsVariants } => ({
  variant: ComponentsVariants.RICH_TEXT,
  ...resolveRichTextContent({ rawVal: raw }),
});
